import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LazySection } from './LazySection';
const faqs = [{
  q: '¿Esto es lo mismo que las constelaciones familiares?',
  a: 'No. Las constelaciones son un trabajo grupal, con exposición pública, intensidad emocional sin contención posterior, y su base científica está cuestionada por psicólogos reconocidos. Este sistema tiene base en epigenética conductual y psicología transgeneracional — es un proceso estructurado, individual, privado, con estudios científicos citables (Emory 2013, Mount Sinai 2015). Lo hacés sola, a tu ritmo, en tu casa.'
}, {
  q: '¿Necesito tener conocimientos de psicología para hacerlo?',
  a: 'Para nada. Cada módulo está diseñado para que cualquier persona pueda trabajarlo, incluso sin haber hecho terapia antes. El lenguaje es accesible, los ejercicios están guiados paso a paso, y hay ejemplos resueltos en cada sección. Solo necesitás disposición y honestidad con vos misma.'
}, {
  q: '¿Puedo hacerlo sin un profesional al lado?',
  a: 'Sí. Todo el sistema está pensado para trabajarlo de forma autónoma. No reemplaza la terapia — la complementa. De hecho, muchas usuarias lo usan para llegar a su terapia con el mapa ya armado, aprovechando mejor cada sesión.'
}, {
  q: 'Ya compré cursos parecidos y no funcionaron. ¿Por qué este sería distinto?',
  a: 'Porque la mayoría de los cursos te dan conocimiento — este te da herramientas aplicables desde el día 1. La diferencia entre entender un patrón y trabajarlo. Los libros explican. La meditación relaja. Este sistema te hace hacer: trazás tu genograma, escribís tu anamnesis, hacés las cartas, completás el diario. Cuando terminás cada módulo, algo cambió — no solo entendiste algo nuevo.'
}, {
  q: 'Me da miedo lo que pueda encontrar. ¿Es normal?',
  a: 'Completamente normal. De hecho, ese miedo es una señal de que algo dentro tuyo ya sabe que hay algo importante por mirar. El sistema está diseñado en etapas — vas a tu ritmo, con herramientas de contención en cada paso. No hay nada que tengas que enfrentar de golpe. Lo que aparece, aparece con herramientas para soltarlo al lado.'
}, {
  q: '¿Cuánto tiempo necesito para hacer el proceso?',
  a: 'Con 20–30 minutos al día avanzás muy bien. Algunas mujeres hacen un módulo por semana, otras uno por mes. No hay fechas ni urgencias impuestas — el acceso es para siempre. El primer momento de claridad suele aparecer en la primera sesión de genograma, que lleva aproximadamente 90 minutos.'
}, {
  q: '¿Sirve si no vivo en Argentina?',
  a: 'Sí. El contenido funciona en cualquier país hispanohablante porque los patrones generacionales son universales — cambian los apellidos, no las dinámicas. El sistema está escrito en español neutro y los ejemplos son aplicables a cualquier sistema familiar latinoamericano o español.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después del pago recibís un correo con el acceso completo. Todo el material es digital — podés descargarlo, imprimirlo o trabajarlo desde cualquier dispositivo. Sin esperas, sin envíos. Y es completamente privado: nadie tiene que saber que lo estás haciendo. Excepto vos.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <LazySection className="bg-cream !py-[80px] md:!py-[100px]" data-id="element-130">
      <div className="container-custom" data-id="element-131">
        <div className="text-center" data-id="element-132">
          <span className="eyebrow" data-id="element-133">Antes de decidir</span>
        </div>
        <h2 className="text-center text-[clamp(30px,4.5vw,42px)] mb-10" data-id="element-134">
          Las preguntas que <em data-id="element-135">ya te estás haciendo</em>
        </h2>

        <div className="max-w-[780px] mx-auto" data-id="element-136">
          {faqs.map((faq, i) => <div key={i} className="border-b border-border py-5" data-id="element-137">
              <button onClick={() => toggleFAQ(i)} className="w-full text-left font-serif text-[19px] font-medium cursor-pointer flex justify-between items-start gap-5 bg-transparent border-none p-0 text-ink" data-id="element-138">
                {faq.q}
                <span className={`text-[26px] text-gold-dark font-light leading-none shrink-0 transition-transform duration-250 ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-139">
                  +
                </span>
              </button>
              <AnimatePresence data-id="element-140">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-141">
                    <p className="mt-3.5 text-ink-soft text-[15px] leading-[1.65] pb-2" data-id="element-142">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </LazySection>;
}